<template>
  <div class="main__content">
    <div class="main__content__top">
      <h1 class="main__content__h1">Сервис прицепов "СЕРПРИ-АВТО"</h1>
      <p class="main__content__p spacy">контакты сервисных центров</p>
    </div>

    <div class="main__content__center">
      <h2 class="main__content__h2 center">Офис:</h2>
      <p class="main__content__p center"><a href="tel:+7(495)712-56-54">+7 (495) 712-56-54</a>, <a href="tel:+7(495)712-71-32">+7 (495) 712-71-32</a>, <a href="tel:+7(495)971-21-82">+7 (495) 971-21-82</a></p>

      <h2 class="main__content__h2 center">Сервисный центр:</h2>
      <p class="main__content__p center"><a href="tel:+7(901)547-21-78">+7 (901) 547-21-78</a>, <a href="tel:+7(901)585-63-60">+7 (901) 585-63-60</a></p>

      <h2 class="main__content__h2 center">Отдел запчастей:</h2>
      <p class="main__content__p center"><a href="tel:+7(901)584-83-37">+7 (901) 584-83-37</a>, <a href="tel:+7(495)988-01-22">+7 (495) 988-01-22</a></p>

      <h2 class="main__content__h2 center">Отдел бухгалтерии:</h2>
      <p class="main__content__p center"><a href="tel:+7(901)584-83-55">+7 (901) 584-83-55</a></p>


      <div class="grid-align-items-center grid-justify-items-center">
        <h1 class="main__content__h1 spacy">СЕРПРИ-АВТО Бутово-Щербинка</h1>
        <p class="main__content__p">контакты сервисного центра</p>
      </div>

      <h2 class="main__content__h2">Адреса и телефоны:</h2>
      <p class="main__content__p justify"><strong>Адрес:</strong> Москва, Варшавское шоссе владение 248 строение 11</p>
      <p class="main__content__p justify"><strong>Тел.:</strong> <a href="tel:+7(901)547-21-78">+7 (901) 547-21-78</a>, <a href="tel:+7(901)585-63-60">+7 (901) 585-63-60</a></p>
      <h2 class="main__content__h2">Как проехать к «СЕРПРИ-АВТО Бутово-Щербинка»:</h2>
      <p class="main__content__p bottom_spacy justify">В навигаторе для ориентира набираете «Варшавское шоссе дом 226», (частный дом на Варшавском шоссе), за домом поворот направо, прямо 150 метров, проезжаете КПП ПЭК, далее через 100 метров слева перед Вами вывеска «Ремонт полуприцепов» и въезд в «Сервисный центр СЕРПРИ-АВТО». (напротив въезда в «Совтрансавто»)</p>

      <yandex-map
        :coords="coords.sherbinka"
        :zoom='15'
        @click="onClick">
        <ymap-marker
          marker-id="sherbinka"
          :coords="coords.sherbinka"
          :balloon-template="sherbinka"
        ></ymap-marker>
      </yandex-map>

      <div class="grid-align-items-center grid-justify-items-center">
        <h1 class="main__content__h1 spacy">СЕРПРИ-АВТО Ганусово</h1>
        <p class="main__content__p">контакты сервисного центра</p>
      </div>

      <h2 class="main__content__h2">Адреса и телефоны:</h2>
      <p class="main__content__p justify"><strong>Адрес:</strong> МО, деревня Ганусово, Промпарк А-107</p>
      <p class="main__content__p justify"><strong>Тел.:</strong> <a href="tel:+7(977)689-09-60">+7 (977) 689-09-60</a>, <a href="tel:+7(901)547-21-82">+7 (901) 547-21-82</a></p>
      <h2 class="main__content__h2">Как проехать к «СЕРПРИ-АВТО Ганусово» (рядом г.Бронницы):</h2>
      <p class="main__content__p bottom_spacy justify">В навигаторе для ориентира набираете деревня Ганусово Промзона. Вы приезжаете на КПП ПРОМПАРК А-107. Охране на КПП говорите, на ремонт в СЕРВИС ПРИЦЕПОВ СЕРПРИ, далее двигаемся только прямо 300 метров (согласно указателям на столбах «СЕРВИС ПРИЦЕПОВ»), перед поворотом налево, вывеска «Ремонт полуприцепов» и въезд в «Сервисный центр СЕРПРИ-АВТО».</p>

      <yandex-map
        :coords="coords.ganusovo"
        :zoom='15'
        @click="onClick">
        <ymap-marker
          marker-id="ganusovo"
          :coords="coords.ganusovo"
          :balloon-template="ganusovo"
        >
        </ymap-marker>
      </yandex-map>
    </div>

    <div class="main__footer">
      <p class="main__footer__p">ООО «Серпри-Авто», 2007 - 2023</p>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    coords: {
      sherbinka: [ 55.532385, 37.573438 ],
      ganusovo: [55.36623597323097,38.078814535908954]
    }
  }),
  computed: {
    sherbinka() {
      return `
        <span class="main__content__map__span">Сервисный центр "СЕРПРИ-АВТО Бутово-Щербинка"</span>
        <ul class="main__content__map__ul">
          <li class="main__content__map__li"><a href="tel:+7(901)547-21-78">+7 (901) 547-21-78</a></li>
          <li class="main__content__map__li"><a href="tel:+7(901)585-63-60">+7 (901) 585-63-60</a></li>
        </p>
        </br>
        <p class="main__content__map__p">Наши координаты:</br>${this.coords.sherbinka}</p>
      `
    },
    ganusovo() {
      return `
        <span class="main__content__map__span">Сервисный центр "СЕРПРИ-АВТО Ганусово"</span>
        <ul class="main__content__map__ul">
          <li class="main__content__map__li"><a href="tel:+7(977)689-09-60">+7 (977) 689-09-60</a></li>
          <li class="main__content__map__li"><a href="tel:+7(901)547-21-82">+7 (901) 547-21-82</a></li>
        </p>
        </br>
        <p class="main__content__map__p">Наши координаты:</br>${this.coords.ganusovo}</p>
`
    }
  },
  methods: {
    onClick(e) {
      this.coords = e.get('coords');
    }
  }
}
</script>

<style lang='sass'>
  @import '@/assets/sass/_main.sass'
  @import '@/assets/sass/_sidebar.sass'
  @import '@/assets/sass/_header.sass'
  @import '@/assets/sass/_footer.sass'
  @import '@/assets/sass/_maps.sass'
  @import '@/assets/sass/_contact.sass'
  @import '@/assets/sass/_media.sass'
</style>
